import withResponsive from '../hoc/withResponsive'
import onResize from '../utils/onResize'
import SwiperCore, { Pagination, Navigation } from 'swiper/core'
import 'swiper/css'

SwiperCore.use([Pagination, Navigation])

export default withResponsive({
  name: 'slider',

  ui: {
    pagination: '[js-slider-pagination]',
    navigation: '[js-slider-navigation]',
    slider: '[js-slider-el]',
  },

  componentDidMount () {
    this.off = onResize(this.onResize.bind(this))

    if (this.props.options) {
      this.props.options.pagination = {
        el: this.ui.pagination,
        type: 'bullets',
        clickable: true,
      }
    }

    if (this.ui.navigation) {
      this.props.options.navigation = {
        nextEl: this.ui.navigation.querySelector('[js-slider-next]'),
        prevEl: this.ui.navigation.querySelector('[js-slider-prev]'),
      }
    }

    this.slider = new SwiperCore(this.ui.slider, this.props.options)

    if (this.slider && this.slider.slides !== undefined) {
      this.checkDisable()
    }

    if (this.props.hpTalents) {
      this.slider.on('slideChange', () => {
        this.slider.slides.forEach((slide, i) => {
          if (i <= this.slider.activeIndex) {
            slide.classList.add('is-big')
          } else {
            slide.classList.remove('is-big')
          }
        })

        this.slider.update()
      })
    }
  },

  componentWillUnmount () {
    this.off()

    this.slider.destroy()
    if (this.ui.pagination) this.ui.pagination.innerHTML = ''
  },

  onResize () {
    if (this.slider && this.slider.slides !== undefined) {
      setTimeout(() => {
        this.checkDisable()
      }, 500)
    }
  },

  checkDisable () {
    if (this.slider.slides !== 'undefined' && this.slider.slides !== null) {
      const nbSlides = this.slider.slides.length

      if (window.innerWidth < 768 && nbSlides < 2) {
        this.slider.allowTouchMove = false
        if (this.ui.pagination) this.ui.pagination.classList.add('is-hidden')
      } else {
        this.slider.allowTouchMove = true
        if (this.ui.pagination) this.ui.pagination.classList.remove('is-hidden')
      }

      if (this.props.options.breakpoints) {
        Object.entries(this.props.options.breakpoints).forEach((breakpoint) => {
          if (
            window.innerWidth >= breakpoint[0] &&
            nbSlides / breakpoint[1].slidesPerView <= 1
          ) {
            this.slider.allowTouchMove = false
            if (this.ui.pagination) this.ui.pagination.classList.add('is-hidden')
          } else {
            this.slider.allowTouchMove = true
            if (this.ui.pagination) {
              this.ui.pagination.classList.remove('is-hidden')
            }
          }
        })
      }
    }
  },
})
